// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchUrl = exports.HubName = exports.LaunchBrowser = void 0;
class LaunchBrowser {
}
exports.LaunchBrowser = LaunchBrowser;
LaunchBrowser.chrome = "pwa-chrome";
LaunchBrowser.edge = "pwa-msedge";
class HubName {
}
exports.HubName = HubName;
HubName.teams = "Teams";
HubName.outlook = "Outlook";
HubName.office = "the Microsoft 365 app";
class LaunchUrl {
}
exports.LaunchUrl = LaunchUrl;
LaunchUrl.teamsLocal = "https://teams.microsoft.com/l/app/${localTeamsAppId}?installAppPackage=true&webjoin=true&${account-hint}";
LaunchUrl.teamsRemote = "https://teams.microsoft.com/l/app/${teamsAppId}?installAppPackage=true&webjoin=true&${account-hint}";
LaunchUrl.outlookLocalTab = "https://outlook.office.com/host/${localTeamsAppInternalId}?${account-hint}";
LaunchUrl.outlookRemoteTab = "https://outlook.office.com/host/${teamsAppInternalId}?${account-hint}";
LaunchUrl.outlookLocalBot = "https://outlook.office.com/mail?${account-hint}";
LaunchUrl.outlookRemoteBot = "https://outlook.office.com/mail?${account-hint}";
LaunchUrl.officeLocalTab = "https://www.office.com/m365apps/${localTeamsAppInternalId}?auth=2&${account-hint}";
LaunchUrl.officeRemoteTab = "https://www.office.com/m365apps/${teamsAppInternalId}?auth=2&${account-hint}";
//# sourceMappingURL=constants.js.map